import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import Forms from '../common/forms';
import { closeModal, openModal } from '../common/simpleModal';

export default class FormularioRevendedor {
    constructor() {
        this.section = document.querySelector('.modal-formulario-revendedor');
        this.form = document.querySelector('#resaleForm');
        this.formFields = this.form.querySelectorAll('input, select, textarea');
        this.successMessage = this.section.querySelector('.success-form');
        this.errorMessage = this.section.querySelector('.error-form');
        this.btnSubmit = this.form.querySelector('button');

        this.closeButton = this.section.querySelector('.close-modal');

        new Forms();

        this.ready();
        this.initRecaptcha();
    }

    ready() {
        if (document.querySelector('.btnOpenModalFormulario')) {
            document.querySelector('.btnOpenModalFormulario').addEventListener('click', () => {
                openModal('.modal-formulario-revendedor');

                if (window.location.hash !== '#revendedor') {
                    history.pushState(null, '', '#revendedor');
                }
            });
        }

        this.closeButton.addEventListener('click', () => {
            closeModal('.modal-formulario-revendedor');

            if (window.location.hash === '#revendedor') {
                history.replaceState(null, '', window.location.pathname + window.location.search);
            }
        });

        new Bouncer(`#resaleForm`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });

        this.form.addEventListener(
            'bouncerShowError',
            () => {
                this.errorMessage.classList.remove('hidden');
            },
            false
        );

        this.form.addEventListener(
            'bouncerFormInvalid',
            () => {
                Forms.activeErros(this.form);
            },
            false
        );

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendForm(event.target);
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formFields.forEach((field) => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            });
        });
    }

    sendForm(form) {
        Forms.setLoading(this.btnSubmit, true);

        const dataForm = new FormData(form);

        if (this.form.querySelector('#accepted').checked) {
            dataForm.set('accepted', 1);
        } else {
            dataForm.set('accepted', 0);
        }

        axios({
            method: 'POST',
            url: base_url + 'sendResaler',
            data: dataForm,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(() => {
                form.reset();
                Forms.showSuccess(form, this.successMessage, this.errorMessage);
                Forms.setLoading(this.btnSubmit, false);
            })
            .catch(() => {
                console.log('Erro');
                Forms.showError(this.errorMessage, this.successMessage);
                Forms.setLoading(this.btnSubmit, false);
            });
        // })
    }
}
if (document.querySelector('.modal-formulario-revendedor')) {
    new FormularioRevendedor();

    if (window.location.hash === '#revendedor') {
        openModal('.modal-formulario-revendedor');
    }
}
